module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4>A secure password must include:</h4>\n\n<ul>\n    <li class="upper-case">One upper case letter.</li>\n    <li class="lower-case">One lower case letter.</li>\n    <li class="digit">One number.</li>\n    <li class="special-character">One special character.</li>\n    <li class="length">Minimum 8 characters.</li>\n</ul>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/user/PasswordQualityView.tpl
// module id = 2794
// module chunks = 0